<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-user-id-confirmation">
      <p class="title title-double-line">接続識別名称変更<span class="mini">-&nbsp;塔経市帝電子異界接続許可情報変更届&nbsp;-</span></p>

      <div class="content content-center">
        <p>異界舞踏会・アキバトリカルを御愛顧いただきまして誠にありがとう御座います。</p>
        <p>ご登録いただきましたユーザーIDでございますが、塔経市帝と日本の微妙な言語差を考慮しきれず、本来であれば登録が出来ない文字列が登録できるようになってございました。</p>
        <p>つきましては、お手数ではございますが、ユーザーIDを再度御登録の上、電子異界渡航を御楽しみいただければ幸いで御座います。</p>
        <p>御面倒ではございますが、何卒御贔屓に御願い申し上げます。</p>
        <hr class="pa-fix-hr" />

      <PaFrontForm
        :action="'/'"
        :formSet="formSet"
        :submitText="'設定する'"
        :submitLoading="submitLoading"
        @handleSubmit="handleSubmit"
      />
      </div>
    </div>
  </section>
</template>

<script>
import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

import FrontPageMixins from '@/mixins/FrontPageMixins'

import {GetMe}  from '@/graphql/queries/User.graphql'
import {UpdateUsername} from '@/graphql/mutations/User.graphql'

export default {
  mixins : [
    FormValidationControlMixin,
    FrontPageMixins
  ],

  components : {
    PaFrontForm
  },

  data(){
    return {
      submitLoading : false,
      formSet       : {
        name  : {
          name            : 'name',
          label           : 'ユーザーID',
          description     : ' \
            <p>アキバトリカル内で使用する半角英数字のIDです。半角英数字とアンダーバー（_）、ハイフン（-）を使用できます。最初の一文字目は英字のみ指定可能です。数字と記号は二文字目から使用可能です。</p> \
            <p>他の人が使用している場合、同じIDは登録できません。登録したIDは後から変更できません。</p> \
          ',
          validationRules : ['notEmpty', 'alphanumericId', 'firstAlpha', 'max'],
        },
      }
    };
  },

  apollo : {
    me: {
      query: GetMe,
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      },
    }
  },

  watch : {
    me : {
      handler(data){
        // すでにuserとcharacterのIDが設定されている場合はアクセスできません。
        if((data.name !== null) && (data.primaryCharacter.name !== null)){
          this.$router.push({name: 'home'});
        }
      },
      deep: true
    }
  },

  methods : {
    executeChangeUsername(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : UpdateUsername,
          variables : {
            name  : this.formSet['name']['value']
          },
          update    : (store, {data: {UpdateUsername}}) => {
            if(UpdateUsername.status === false){
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;エラーが発生しました。',
                status      : 'error',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});
            }else{
              this.$apollo.queries.me.refetch();

              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;御協力頂きましてありがとうございました。',
                status      : 'success',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          const errorSet = this.getApolloRequestErrorSet(error);

          if(typeof errorSet.first !== 'undefined'){
            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : '&nbsp;'+errorSet.first.message,
              status      : 'error',
              hasControl  : true,
              autoClose   : 8000
            }, {root:true});
          }

          resolve(false);
        });
      });
    },

    async handleSubmit(){
      this.submitLoading = true;
      
      if( this.checkFormPreValidation() ){
        this.disabledFields();

        await this.executeChangeUsername();

        await this.UXWaiting(3000);

        this.$nextTick(() => {
          this.submitLoading = false;
          this.unDisabledFields();
          
          this.$router.push({name: 'home'});
        });
      }else{
        this.submitLoading = false;
        this.unDisabledFields();

        this.flashMessageToScroll({
          status    : 'error',
          text      : '&nbsp;入力項目にエラーが存在します。今一度ご確認ください。',
          autoClose : 1800,
          cancelBtn : false,
        });
      }
    }
  },

  async mounted(){
    await this.initializePage({
      'asLoginedView' : true
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-section{
  &-registration{
    .pa-user-id-confirmation{
      .pa-fix-hr{
        width:80%;
        margin:1rem auto .5rem;
        background-color:#DBC9AA;
      }
    }
  }
}
</style>